import React, { Component } from 'react'
import { message, Button, Icon, Input, InputNumber, Checkbox, Select } from 'utils/ui'
import { observer } from 'mobx-react';
import { createGift, getImage, addImage } from '../api_calls/gift';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';
import FormField from '../common/FormField';
const { TextArea } = Input;
const CheckboxGroup = Checkbox.Group;

const CATEGORY_OPTIONS = [
    { value: 'gift', label: 'Gift (General)' },
    { value: 'books', label: 'Books' },
    { value: 'camping', label: 'Camping' },
    { value: 'clothing', label: 'Clothing' },
    { value: 'tools', label: 'Tools' },
    { value: 'art', label: 'Art' },
    { value: 'food', label: 'Food' },
    { value: 'appliances', label: 'Appliances' },
    { value: 'cosmetics', label: 'Cosmetics' },
    { value: 'technology', label: 'Technology' },
    { value: 'household', label: 'Household' },
    { value: 'board games', label: 'Board Games' },
    { value: 'video games', label: 'Video Games' },
    { value: 'jewelry', label: 'Jewelry' },
    { value: 'gift cards', label: 'Gift Cards' },
    { value: 'tickets', label: 'Tickets' },
    { value: 'd&d', label: 'Dungeons and Dragons' },
    { value: 'toys', label: 'Toys' }
];

const listOfApprovedHosts = ["www.chapters.indigo.ca", "www.bestbuy.ca"];

@observer(['AuthStore', 'UserStore', 'MyListStore', 'FamilyStore'])
class AddGift extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            description: "",
            link: "",
            category: "gift",
            price: 0,
            quantity: 1,
            isInfinite: false,
            modalOpen: false,
            submittingNewGift: false,
            showCheckboxes: false,
            groupCheckboxes: <div></div>,
            checkedList: [],
            indeterminate: true,
            checkAll: false,
            checkedListIds: [],
            plainOptions: []
        };
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onCheckAllChange = this.onCheckAllChange.bind(this);
        this.openModal = this.openModal.bind(this);
    }

    getGroupId(group) {
        return (group && (group.id || group._id)) || "";
    }

    getGroupName(group) {
        return (group && (group.name || group.id || group._id)) || "";
    }

    openModal() {
        const { UserStore, FamilyStore } = this.props;
        const userGroups = (UserStore.user && UserStore.user.groups) ? UserStore.user.groups : [];
        const activeGroupId = FamilyStore.activeGroupId || "";

        if (!activeGroupId && userGroups.length === 0) {
            message.warn("You must be in a group to add gifts!");
            return;
        }

        const normalizedGroups = (userGroups || [])
            .map((group) => ({ id: this.getGroupId(group), name: this.getGroupName(group) }))
            .filter((group) => group.id && group.name);
        const plainOptions = normalizedGroups.map((group) => group.name);
        const activeGroup = normalizedGroups.find((group) => String(group.id) === String(activeGroupId));
        const selectedGroups = activeGroup ? [activeGroup] : (normalizedGroups.length > 0 ? [normalizedGroups[0]] : []);
        const checkedList = selectedGroups.map((group) => group.name);
        const checkedListIds = selectedGroups.map((group) => group.id);

        this.setState({
            modalOpen: true,
            plainOptions,
            showCheckboxes: plainOptions.length > 1,
            checkedList,
            checkedListIds,
            indeterminate: checkedList.length > 0 && checkedList.length < plainOptions.length,
            checkAll: checkedList.length > 0 && checkedList.length === plainOptions.length
        });
    }

    onSubmitClick() {
        const { UserStore, FamilyStore, AuthStore, MyListStore } = this.props;
        const currentUserId = UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
        let auth = UserStore.childViewActive ? UserStore.activeChild.jwt : AuthStore.userAuth.auth.accessToken;
        const { title, description, link, price, category, quantity, isInfinite } = this.state;
        const wisher = currentUserId;
        let self = this;
        let timeWishedFor = Date.now();
        let priceToUse = price;
        let groups = this.state.checkedListIds;

        if (price === null) {
            priceToUse = 0;
        }
        if (this.state.title === "") {
            message.error("Cannot leave title blank");
        }
        else if (groups.length === 0) {
            message.error("Must select at least one group");
        } else {
            this.setState({ submittingNewGift: true });
            createGift(auth,
                title,
                description,
                category,
                priceToUse,
                quantity,
                isInfinite,
                link,
                wisher,
                timeWishedFor,
                groups).then((response) => {
                    self.setState({
                        title: "",
                        description: "",
                        link: "",
                        imageLink: "",
                        price: 0,
                        quantity: 1,
                        modalOpen: false,
                        submittingNewGift: false
                    });
                    MyListStore.loadGiftsForUser(currentUserId, currentUserId, FamilyStore.activeGroupId);
                });
        }
    }

    onChange(checkedList) {
        const { UserStore } = this.props;       
        let idArray = [];
        UserStore.user.groups.forEach((group) => {
            if (checkedList.includes(this.getGroupName(group))) {
                idArray.push(this.getGroupId(group));
            }
        });
        this.setState({
            checkedList,
            checkedListIds: idArray,
            indeterminate: !!checkedList.length && checkedList.length < this.state.plainOptions.length,
            checkAll: checkedList.length === this.state.plainOptions.length,
        });
    }

    onCheckAllChange(e) {
        const { UserStore } = this.props;
        this.setState({
            checkedList: e.target.checked ? this.state.plainOptions : [],
            checkedListIds: e.target.checked ? UserStore.user.groups.map(group => this.getGroupId(group)).filter(Boolean) : [],
            indeterminate: false,
            checkAll: e.target.checked,
        });
    }   

    render() {
        return (
            <div>
            <ModalShell
                className="register-modal"
                overlayClassName="register-modal-overlay"
                isOpen={this.state.modalOpen}
                onRequestClose={() => { (this.state.submittingNewGift ? console.log("tried to close") : this.setState({ modalOpen: false })) }}
                maxWidth={760}
            >
                {!this.state.submittingNewGift ? (
                <ModalBody>
                    <div className="ui-modal-stack">
                    <FormField label="Title" style={{ marginBottom: '1rem' }}>
                        <Input
                            size="large"
                            maxLength={60}
                            value={this.state.title}
                            onChange={(e) => { this.setState({ title: e.target.value }) }}
                            placeholder="Brand Name Widget"
                            style={{ borderRadius: 6 }}
                        />
                    </FormField>

                    <FormField label="Description" style={{ marginBottom: '1rem' }}>
                        <TextArea
                            onChange={(e) => { this.setState({ description: e.target.value }) }}
                            placeholder="This is a..."
                            autosize={{ minRows: 3, maxRows: 6 }}
                            style={{ borderRadius: 6 }}
                        />
                    </FormField>

                    <div style={{ display: 'flex', flexDirection: 'row', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                        <div style={{ flex: '1 1 160px', minWidth: 140 }}>
                        <FormField label="Price">
                            <InputNumber
                                style={{ width: '100%', borderRadius: 6 }}
                                defaultValue={0.00}
                                min={0}
                                size="large"
                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                onChange={(value) => { this.setState({ price: value }) }}
                            />
                        </FormField>
                        </div>


                        <div style={{ flex: '2 1 240px', minWidth: 180 }}>
                        <FormField label="Link">
                            <Input
                                size="large"
                                onChange={(e) => { this.setState({ link: e.target.value }) }}
                                placeholder="https://example.com/..."
                                style={{ borderRadius: 6 }}
                            />
                        </FormField>
                        </div>

                        <div style={{ flex: '1 1 120px', minWidth: 120 }}>
                        <FormField label="Quantity Desired">
                            <InputNumber
                                style={{ width: '90%', borderRadius: 6 }}
                                defaultValue={1}
                                min={1}
                                size="large"
                                disabled={this.state.isInfinite}
                                onChange={(value) => { this.setState({ quantity: value }) }}
                            />
                        </FormField>
                        </div>
                        <div style={{ flex: '1 1 10px', minWidth: 10 }}>
                            or
                        </div>

                        <div style={{ flex: '1 1 80px', minWidth: 80 }}>
                            <span style={{fontWeight: 'bold'}}>Always Wanted</span> <Checkbox onChange={(value) => { this.setState({ isInfinite: value.target.checked }) }} />
                        </div>
                        

                        <div style={{ flex: '1 1 180px', minWidth: 160 }}>
                        <FormField label="Category">
                            <Select
                                value={this.state.category}
                                onChange={(value) => { this.setState({ category: value }) }}
                                style={{ width: '100%', borderRadius: 6 }}
                            >
                                {CATEGORY_OPTIONS.map((option) => (
                                    <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                                ))}
                            </Select>
                        </FormField>
                        </div>
                    </div>

                    {this.state.showCheckboxes ? (
                        <div style={{
                        marginTop: 6,
                        padding: 12,
                        background: '#fafafa',
                        borderRadius: 8,
                        color: '#333'
                        }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                            <div style={{ fontWeight: 600 }}>Select which groups can see this gift</div>
                            <Checkbox
                            indeterminate={this.state.indeterminate}
                            onChange={this.onCheckAllChange.bind(this)}
                            checked={this.state.checkAll}
                            >
                            Check all
                            </Checkbox>
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <CheckboxGroup
                            options={this.state.plainOptions}
                            value={this.state.checkedList}
                            onChange={this.onChange.bind(this)}
                            />
                        </div>
                        </div>
                    ) : null}

                    <div className="ui-modal-actions">
                        <Button
                        className="AppFont btn-cancel ui-btn-danger"
                        onClick={() => { this.setState({ modalOpen: false }) }}
                        size="large"
                        >
                        <Icon type="close" /> Cancel
                        </Button>

                        <Button
                        className="AppFont btn-submit ui-btn-success"
                        onClick={this.onSubmitClick.bind(this)}
                        size="large"
                        >
                        <Icon type="check-circle" /> Submit
                        </Button>
                    </div>
                    </div>
                </ModalBody>
                ) : (
                <div style={{
                    width: 160,
                    height: 160,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    margin: '120px auto 40px'
                }}>
                    <Icon type="loading" style={{ fontSize: 48, color: '#007bff' }} />
                </div>
                )}
            </ModalShell>

            <div>
                <div
                style={{
                    ...this.props.divStyle,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '8px 12px',
                    borderRadius: 6,
                    color: '#fff',
                    cursor: 'pointer',
                    userSelect: 'none',
                    fontWeight: 600
                }}
                onClick={this.openModal}
                size="large"
                >
                <Icon style={{ fontSize: 14, paddingRight: 4 }} type="gift" /> Add Gift
                </div>
            </div>
            </div>
        )
    }
}
export default AddGift;
